/**
 * Whether a listing is known to hold only one clearinghouse's ERAs — read from the rows, never assumed.
 *
 * - 'confirmed'   — every row carries this clearinghouse's id (or there are no rows to doubt);
 * - 'ignored'     — some row carries ANOTHER clearinghouse's id, so the backend dropped the filter;
 * - 'unconfirmed' — rows carry no clearinghouse id to check against (the field is in the model, but the
 *                   backend may leave it empty).
 *
 * No import on purpose: it runs under the node-only jest config, which cannot load the core barrel.
 */
export type EraScope = 'confirmed' | 'unconfirmed' | 'ignored';

export function eraScope(
    rows: ReadonlyArray<{ clearinghouseId?: unknown } | null | undefined>,
    clearinghouseId: string,
): EraScope {
    const ids = rows.map(row => row?.clearinghouseId);
    if (ids.every(id => id === clearinghouseId)) {
        return 'confirmed';
    }
    if (ids.some(id => id !== undefined && id !== null && id !== clearinghouseId)) {
        return 'ignored';
    }
    return 'unconfirmed';
}
